<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-bg-variant="primary">
                <div slot="header">
                  <strong>
                    <!--                    รายชื่อบัณฑิตที่ยังขึ้นทะเบียนบัณฑิต-->
                    <!--                    <u>ไม่สำเร็จ</u>(ทั้งหมด)-->
                    รายชื่อบัณฑิตบันทึกข้อมูล<font color="red" size="+1">ไม่สมบูรณ์ </font>
                    <!--                    <u>(ทั้งหมด)</u>-->
                  </strong>
                </div>
<!--                <b-button type="submit" size="md" class="mr-2" variant="danger" @click="onSubmit">-->
<!--                  <i class="fa fa-file-excel-o"></i> Download Excel-->
<!--                </b-button>-->
                <b-row>
                  <b-col lg="1"></b-col>
                  <b-col lg="10">
                    จำนวน {{ countrow }}
                    <b-table striped hover :items="items" :fields="fields"></b-table>
                  </b-col>
                  <b-col lg="1"></b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      fields: [
        {
          key: "STUDENTCODE",
          label: "รหัสประจำตัวนักศึกษา",
          formatter: "STUDENTCODE"
        },
        {
          key: "STUDENTNAME",
          label: "ชื่อ",
          formatter: "STUDENTNAME"
        },
        {
          key: "STUDENTSURNAME",
          label: "นามสกุล",
          formatter: "STUDENTSURNAME"
        },
        {
          key: "FACULTYNAME",
          label: "สำนักวิชา",
          formatter: "FACULTYNAME"
        },
        {
          key: "LEVELGROUPNAME",
          label: "ปริญญา",
          formatter: "LEVELGROUPNAME"
        }
      ],
      items: [],
      i: 0,
      countrow:0,
      thaistudent:"",
      facultyid:"",
      levelid :"",
      deptid :"",
      groupid :"",
      year :"",
    };
  },

  methods: {
    onSubmit(){
      if (!Number.isInteger(this.facultyid)) {
        this.facultyid=0;
      }
      if (!Number.isInteger(this.deptid)) {
        this.deptid=0;
      }
      if (!Number.isInteger(this.groupid)) {
        this.groupid=0;
      }
      this.$router.push("/Excelincomp?year="+this.year+"&level="+this.levelid+"&id="+this.facultyid+"&dept="+this.deptid+"&group="+this.groupid);
    },

    getStatistic(thaistudent, faculty, level, dept,group,year) {
      api
        .getStatisticIn_DeptCompleted(thaistudent, faculty, level, dept,group,year)
        .then(res => {
          this.countrow = res.data.data.length;
          this.items = res.data.data;
          // console.log(this.items);
        //  console.log(res);
        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    this.facultyid = parseInt(this.$route.query.id);
    this.levelid = parseInt(this.$route.query.level);
    this.deptid = parseInt(this.$route.query.dept);
    this.groupid = parseInt(this.$route.query.group);
    this.year = parseInt(this.$route.query.year);
    this.thaistudent= parseInt(this.$route.query.thai);
    // console.log("facultyid==",this.facultyid)
    if (Number.isInteger(this.facultyid)) {
      if (this.thaistudent !=null){
        this.getStatistic(this.thaistudent, this.facultyid, this.levelid, 0, 0, this.year);
      }else {
        this.getStatistic(2, this.facultyid, this.levelid, 0, 0, this.year);
      }
    } else {
      if (Number.isInteger(this.deptid)) {
        this.getStatistic(2, 0, this.levelid, this.deptid, this.groupid,this.year);
      } else {
        if (this.thaistudent !=null) {
          this.getStatistic(this.thaistudent, 0, 0, 0, 0, this.year);
        }else{
          this.getStatistic(2, 0, 0, 0, 0, this.year);
          // this.getStatistic(0, 0, 0, 0, 0, this.year);
        }
      }
    }
    api.onSetHeader();
  }
};
</script>
<style>
</style>
